import { render, staticRenderFns } from "./CallActivity.vue?vue&type=template&id=020384f0&scoped=true&"
import script from "./CallActivity.vue?vue&type=script&lang=js&"
export * from "./CallActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020384f0",
  null
  
)

export default component.exports